<template>
  <div>
    <b-row>
      <b-col md="3">
        <InputSelectTyping
          ref="matriculaId"
          :options="pessoasFiltradas"
          v-model="filtro.matriculaId"
          :label="$t('ACADEMICO_MATRICULAS.ALUNO')"
          placeholder="Selecione ou digite"
          @pesquisa-nome="pesquisaPorNome"
          :loading="loadingPessoas"
        />
      </b-col>
      <b-col md="3">
        <input-date-only-btn
          ref="dataInicio"
          v-model="filtro.dataInicio"
          label="FINANCEIRO_CONTAS_PAGAR.DATA_VENCIMENTO_INICIAL"
          placeholder="FINANCEIRO_CONTAS_PAGAR.DATA_PLACEHOLDER"
          required
        />
      </b-col>
      <b-col md="3">
        <input-date-only-btn
          ref="dataFim"
          v-model="filtro.dataFim"
          label="FINANCEIRO_CONTAS_PAGAR.DATA_VENCIMENTO_FINAL"
          placeholder="FINANCEIRO_CONTAS_PAGAR.DATA_PLACEHOLDER"
          required
        />
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro mb-3 w-100"
          variant="primary"
          @click="filtrar"
          :disabled="!validarFiltro"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro w-100"
          variant="secondary"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </b-col>
      <b-col md="2">
        <input-text
          ref="totalAlunos"
          v-model="totalAlunos"
          label="FINANCEIRO.TOTAL_ALUNOS"
          disabled
        />
      </b-col>
      <b-col md="3">
        <input-text
          ref="totalContasReceberAberto"
          v-model="totalContasReceberAberto"
          label="FINANCEIRO.TOTAL_CONTAS_RECEBER_ABERTO"
          disabled
        />
      </b-col>
      <b-col md="auto">
        <b-button
          variant="info"
          class="botao-acao-filtro mb-3 w-100"
          @click.prevent="gerarBoletos"
        >
          {{ $t('FINANCEIRO_CONTAS_RECEBER.GERAR_BOLETO') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro mb-3 w-100"
          variant="info"
          @click="liberarPortalAluno"
        >
          {{ $t('FINANCEIRO_CONTAS_RECEBER.LIBERAR_PORTAL') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro mb-3 w-100"
          variant="info"
          @click="bloquearPortalAluno"
        >
          {{ $t('FINANCEIRO_CONTAS_RECEBER.BLOQUEAR_PORTAL') }}
        </b-button>
      </b-col>
    </b-row>
    <b-table
      v-if="items.length"
      :fields="fields"
      :items="items"
      class="mt-4"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      show-empty
      striped
      hover
    >
      <template #cell(acoes)="item">
        <div>
          <b-button
            v-if="item.item.boletosLogs.length && podeVisualizar"
            size="sm"
            variant="primary"
            @click="abreModalVerLogs(item)"
          >
            {{ $t('GERAL.VER_LOGS') }}
          </b-button>
        </div>
      </template>
    </b-table>
    <modal
      :titulo="'Logs'"
      id="modalLogs"
      :exibir="exibir"
      @fechar="fecharModal"
      :campos="$refs"
      tamanho="xl"
      scrollable
      :ocultarRodape="true"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <b-row class="align-items-end mt-4">
              <b-col md="auto">
                <div class="mb-3">
                  <b-button
                    class="mr-3"
                    :variant="
                      filtroSituacao === 'todos' ? 'primary' : 'outline-primary'
                    "
                    @click="selecionarSituacao('todos')"
                  >
                    {{ $t('GERAL.TODOS') }}
                    <b-badge variant="light">{{ itemsLogs.length }}</b-badge>
                  </b-button>
                  <b-button
                    class="mr-3"
                    :variant="
                      filtroSituacao === 'erro' ? 'danger' : 'outline-danger'
                    "
                    @click="selecionarSituacao('erro')"
                  >
                    {{ $t('GERAL.ERRO') }}
                    <b-badge variant="light">{{ totalErros }}</b-badge>
                  </b-button>
                  <b-button
                    :variant="
                      filtroSituacao === 'sucesso'
                        ? 'success'
                        : 'outline-success'
                    "
                    @click="selecionarSituacao('sucesso')"
                  >
                    {{ $t('GERAL.SUCESSO') }}
                    <b-badge variant="light">{{ totalSucessos }}</b-badge>
                  </b-button>
                </div>
              </b-col>
              <b-col md="4">
                <b-form-group :label="$t('GERAL.PESQUISAR')">
                  <b-form-input
                    v-model="buscaLog"
                    type="search"
                    placeholder="Código ou mensagem"
                  />
                </b-form-group>
              </b-col>
              <b-col md="auto">
                <b-button
                  class="mb-3"
                  variant="secondary"
                  @click="limparFiltroLogs"
                >
                  {{ $t('GERAL.LIMPAR') }}
                </b-button>
              </b-col>
              <b-col md="2">
                <b-form-group :label="$t('GERAL.EXIBIR')">
                  <b-form-select
                    v-model="porPaginaLogs"
                    :options="opcoesPorPaginaLogs"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <div v-if="resumoErros.length" class="mb-3">
              <b-button
                variant="link"
                class="p-0"
                @click="exibirResumoErros = !exibirResumoErros"
              >
                {{
                  exibirResumoErros
                    ? 'Ocultar resumo dos erros'
                    : `Ver resumo dos erros (${resumoErros.length} tipos)`
                }}
              </b-button>
              <b-collapse v-model="exibirResumoErros">
                <b-list-group class="mt-2">
                  <b-list-group-item
                    v-for="(resumo, indice) in resumoErros"
                    :key="indice"
                    button
                    class="d-flex justify-content-between align-items-center"
                    @click="filtrarPorMensagem(resumo.mensagem)"
                  >
                    <span>{{ resumo.mensagem }}</span>
                    <b-badge variant="danger" pill>
                      {{ resumo.quantidade }}
                    </b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
            </div>
            <b-table
              v-if="itemsLogs.length"
              :fields="fieldsLogs"
              :items="logsFiltrados"
              :filter="buscaLog"
              :current-page="paginaLogs"
              :per-page="porPaginaLogs"
              @filtered="aoFiltrarLogs"
              class="mt-2"
              :empty-text="$t('GERAL.NENHUM_REGISTRO')"
              :empty-filtered-text="$t('GERAL.NENHUM_REGISTRO')"
              head-variant="light"
              show-empty
              striped
              hover
            >
              <template #cell(situacao)="item">
                <b-badge
                  :variant="
                    item.item.boletoCriadoComSucesso ? 'success' : 'danger'
                  "
                >
                  {{ item.item.situacao }}
                </b-badge>
              </template>
            </b-table>
            <b-row v-if="itemsLogs.length" class="align-items-center mt-2">
              <b-col md="6">
                {{
                  $t('GERAL.TOTAL_REGISTROS').formatUnicorn({
                    count: totalLogsExibidos,
                  })
                }}
              </b-col>
              <b-col md="6">
                <b-pagination
                  v-model="paginaLogs"
                  :total-rows="totalLogsExibidos"
                  :per-page="porPaginaLogs"
                  class="justify-content-end mb-0"
                />
              </b-col>
            </b-row>
            <div class="mt-5" style="text-align-last: right">
              <b-button variant="secondary" @click="fecharModal">
                {{ $t('GERAL.FECHAR') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import helpers from '@/common/utils/helpers';
import Modal from '@/components/modal/Modal.vue';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import MatriculaService from '@/common/services/matriculas/matriculas.service';
import ContasReceberService from '@/common/services/conta-receber/contaReceber.service';
import BoletimService from '@/common/services/boletim/boletim.service';

// Components:
import {
  InputSelectTyping,
  InputDateOnlyBtn,
  InputText,
} from '@/components/inputs';

export default {
  mixins: [Permissoes],
  name: 'filtroGerenciarBoletos',
  components: {
    InputSelectTyping,
    InputDateOnlyBtn,
    InputText,
    Modal,
  },
  data() {
    return {
      exibir: false,
      items: [],
      itemsLogs: [],
      filtroSituacao: 'todos',
      buscaLog: '',
      paginaLogs: 1,
      porPaginaLogs: 25,
      totalLogsExibidos: 0,
      exibirResumoErros: false,
      opcoesPorPaginaLogs: [
        { value: 10, text: 10 },
        { value: 25, text: 25 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
      ],
      fieldsLogs: [
        {
          key: 'situacao',
          label: this.$t('GERAL.STATUS'),
          sortable: true,
        },
        {
          key: 'seuNumero',
          label: this.$t('GERAL.SEU_NUMERO'),
          sortable: true,
          formatter: (value) => {
            return value ? value : '-';
          },
        },
        {
          key: 'nossoNumero',
          label: this.$t('GERAL.NOSSO_NUMERO'),
          sortable: true,
          formatter: (value) => {
            return value ? value : '-';
          },
        },
        {
          key: 'mensagemExibicao',
          label: this.$t('PRECOS.DESCRICAO'),
          sortable: true,
        },
      ],
      fields: [
        {
          key: 'codigo',
          label: this.$t('ACADEMICO.CODIGO'),
        },
        {
          key: 'dataInicio',
          label: this.$t('FINANCEIRO_CONTAS_PAGAR.DATA_VENCIMENTO_INICIAL'),
          sortable: true,
          formatter: (value) => {
            return helpers.formatarDataBr(value);
          },
        },
        {
          key: 'dataFim',
          label: this.$t('FINANCEIRO_CONTAS_PAGAR.DATA_VENCIMENTO_FINAL'),
          sortable: true,
          formatter: (value) => {
            return helpers.formatarDataBr(value);
          },
        },
        {
          key: 'statusBoletoDescricao',
          label: this.$t('ACADEMICO.STATUS'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
      totalAlunos: null,
      totalContasReceberAberto: null,
      loadingPessoas: false,
      filtro: {
        matriculaId: null,
        dataInicio: null,
        dataFim: null,
      },
      pessoasFiltradas: [],

      paginacao: { numeroDaPagina: 1, tamanhoDaPagina: 50 },
    };
  },
  mounted() {
    this.$emit('refs', this.$refs);
  },
  computed: {
    validarFiltro() {
      return this.filtro.dataInicio && this.filtro.dataFim;
    },
    logsNormalizados() {
      return this.itemsLogs.map((log) => ({
        ...log,
        situacao: log.boletoCriadoComSucesso
          ? this.$t('GERAL.SUCESSO')
          : this.$t('GERAL.ERRO'),
        mensagemExibicao: log.mensagem ? log.mensagem : 'Criado com Sucesso!',
      }));
    },
    logsFiltrados() {
      if (this.filtroSituacao === 'erro')
        return this.logsNormalizados.filter(
          (log) => !log.boletoCriadoComSucesso
        );

      if (this.filtroSituacao === 'sucesso')
        return this.logsNormalizados.filter((log) => log.boletoCriadoComSucesso);

      return this.logsNormalizados;
    },
    totalErros() {
      return this.itemsLogs.filter((log) => !log.boletoCriadoComSucesso).length;
    },
    totalSucessos() {
      return this.itemsLogs.filter((log) => log.boletoCriadoComSucesso).length;
    },
    resumoErros() {
      let agrupado = {};

      this.logsNormalizados
        .filter((log) => !log.boletoCriadoComSucesso)
        .forEach((log) => {
          agrupado[log.mensagemExibicao] =
            (agrupado[log.mensagemExibicao] || 0) + 1;
        });

      return Object.keys(agrupado)
        .map((mensagem) => ({ mensagem, quantidade: agrupado[mensagem] }))
        .sort((a, b) => b.quantidade - a.quantidade);
    },
  },
  watch: {
    logsFiltrados(valor) {
      this.totalLogsExibidos = valor.length;
      this.paginaLogs = 1;
    },
    buscaLog() {
      this.paginaLogs = 1;
    },
  },
  methods: {
    abreModalVerLogs(item) {
      this.itemsLogs = item.item.boletosLogs;
      this.limparFiltroLogs();
      this.exibir = true;
    },
    limparFiltroLogs() {
      this.filtroSituacao = 'todos';
      this.buscaLog = '';
      this.paginaLogs = 1;
      this.totalLogsExibidos = this.itemsLogs.length;
    },
    selecionarSituacao(situacao) {
      this.filtroSituacao = situacao;
      this.buscaLog = '';
    },
    filtrarPorMensagem(mensagem) {
      this.filtroSituacao = 'erro';
      this.buscaLog = mensagem;
    },
    aoFiltrarLogs(itensFiltrados) {
      this.totalLogsExibidos = itensFiltrados.length;
      this.paginaLogs = 1;
    },
    fecharModal() {
      this.exibir = false;
      this.itemsLogs = [];
      this.exibirResumoErros = false;
      this.limparFiltroLogs();
    },
    gerarBoletos() {
      this.$store.dispatch(START_LOADING);
      BoletimService.gerarBoletos(this.filtro)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    liberarPortalAluno() {
      this.$store.dispatch(START_LOADING);
      ContasReceberService.liberarPortalAluno(this.filtro)
        .then((data) => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            `${data.data.data.mensagem} \n ${data.data.data.informacoesExtra}.`
          );
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    bloquearPortalAluno() {
      ContasReceberService.bloquearPortalAluno(this.filtro)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            'Bloqueio de portal realizada com sucesso!'
          );
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    buscaDadosTabela() {
      BoletimService.gerarListaBoletosLog(this.filtro)
        .then((data) => {
          this.items = data.data;
          if (this.items.length) {
            this.items.forEach((item) => {
              if (item.boletosLogs.length) {
                item.boletosLogs = item.boletosLogs.map((row) => ({
                  ...row,
                  _rowVariant: this.corLinhaContasReceber(row),
                }));
              }
            });
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    corLinhaContasReceber(row) {
      if (row.boletoCriadoComSucesso) return 'success';
      else return 'danger';
    },
    filtrar() {
      this.$store.dispatch(START_LOADING);

      ContasReceberService.buscarQuantidadeFiltro(this.filtro)
        .then((data) => {
          this.totalAlunos = data.totalAlunos;
          this.totalContasReceberAberto = data.totalContasReceber;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.buscaDadosTabela();
        });
    },
    pesquisaPorNome(nome) {
      this.loadingPessoas = true;
      MatriculaService.buscarTodosPorNomeCodigo(nome)
        .then((data) => {
          this.pessoasFiltradas = data.itens;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingPessoas = false;
        });
    },
    limparFiltro() {
      this.totalAlunos = null;
      this.totalContasReceberAberto = null;
      this.filtro = {
        matriculaId: null,
        dataInicio: null,
        dataFim: null,
      };
    },
  },
};
</script>
